export enum HighlightedCollectionType {
  MenuItems = 0,
  Vendors = 1,
  Curation = 2,
  ReOrder = 3,
  NewVendors = 4,
  Wishlists = 5,
}
